import React, { useEffect, useState } from "react";
import { Phone, Menu, X } from "lucide-react";
import { PHONE } from "./PhoneButton";

const NAV = [
  { href: "#benefits", label: "Why Us" },
  { href: "#how-it-works", label: "How It Works" },
  { href: "#coverage", label: "Coverage" },
  { href: "#faq", label: "FAQ" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={[
        "fixed top-0 left-0 right-0 z-50 transition-all duration-200",
        scrolled
          ? "bg-white/95 backdrop-blur-md border-b border-slate-200 shadow-sm"
          : "bg-white border-b border-transparent",
      ].join(" ")}
    >
      <div className="mx-auto max-w-7xl px-5 md:px-10 py-3 md:py-4 flex items-center justify-between gap-4">
        {/* Brand */}
        <a
          href="#top"
          data-testid="brand-logo"
          className="flex items-center gap-2.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 rounded-md"
          aria-label="Affordable Life Coverage home"
        >
          <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-blue-900 text-white font-serif-display font-black text-xl">
            A
          </span>
          <span className="flex flex-col leading-tight">
            <span className="font-serif-display font-bold text-blue-900 text-lg md:text-xl">
              Affordable Life Coverage
            </span>
            <span className="hidden md:block text-xs text-slate-500 tracking-wide">
              Senior Life Insurance Specialists
            </span>
          </span>
        </a>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-base font-medium text-slate-700 hover:text-blue-900 transition-colors"
            >
              {n.label}
            </a>
          ))}
        </nav>

        {/* Call button (desktop) */}
        <a
          href={PHONE.href}
          data-testid="header-call-button"
          aria-label={`Call us at ${PHONE.display}`}
          className="hidden md:inline-flex items-center gap-2 rounded-full bg-green-700 hover:bg-green-800 text-white font-bold px-5 py-3 min-h-[52px] shadow-md transition-colors focus:outline-none focus-visible:ring-4 focus-visible:ring-green-300"
        >
          <Phone className="h-5 w-5 fill-white" />
          <span className="text-base md:text-lg">{PHONE.display}</span>
        </a>

        {/* Mobile menu toggle */}
        <button
          type="button"
          data-testid="mobile-menu-toggle"
          aria-label={open ? "Close menu" : "Open menu"}
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden inline-flex h-12 w-12 items-center justify-center rounded-md text-slate-700 hover:bg-slate-100"
        >
          {open ? <X className="h-7 w-7" /> : <Menu className="h-7 w-7" />}
        </button>
      </div>

      {/* Mobile drawer */}
      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden border-t border-slate-200 bg-white"
        >
          <nav className="px-5 py-4 flex flex-col">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="py-4 text-lg font-medium text-slate-800 border-b border-slate-100"
              >
                {n.label}
              </a>
            ))}
            <a
              href={PHONE.href}
              data-testid="mobile-menu-call"
              className="mt-4 inline-flex items-center justify-center gap-2 rounded-full bg-green-700 hover:bg-green-800 text-white font-bold px-5 py-4 min-h-[60px] text-lg"
            >
              <Phone className="h-5 w-5 fill-white" /> Call {PHONE.display}
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};
